import Reflux from 'reflux';

const WebinarActions = Reflux.createActions([
  'initWebinar',
  'initComplete',
]);

export default WebinarActions;



// WEBPACK FOOTER //
// ./src/js/actions/Webinar.js